module.exports = __webpack_public_path__ + "img/dot.43f2ea49.svg";